module.exports = __webpack_public_path__ + "static/media/lock.b66f64cf.svg";